import { Link } from 'react-router-dom'

import { NICHT_VORHANDEN, api, ohne404 } from '../api'
import { zeitpunkt } from '../format'
import { useLaden } from '../hooks'

/**
 * Abrufe, die SelectLine schon als geliefert führt, deren Wareneingang hier aber noch nicht gebucht ist
 * (`GET /api/selectline/bestellabgleich` → `wareneingang_fehlt`, 02.11.2026). Sie bleiben bestellt, bis der
 * Wareneingang sie schließt - sonst fehlte die Menge in Bestand und Bestellung zugleich (211 t Sanna-Wickler am
 * 15.10.2026). Nach einer Woche ohne Wareneingang steht zusätzlich eine Frage in der Terminliste.
 */
export default function WareneingangFehlt() {
  // Ein älteres Backend kennt den Abgleich nicht - dann steht hier einfach nichts.
  const { daten } = useLaden(() => ohne404(api.bestellabgleich()), [])
  const saetze = daten && daten !== NICHT_VORHANDEN ? (daten.wareneingang_fehlt ?? []) : []
  if (saetze.length === 0 || daten === null || daten === NICHT_VORHANDEN) return null
  return (
    <div className="karte datenpruefung" id="wareneingang-fehlt">
      <div className="leiste">
        <b>Wareneingang fehlt noch</b>
        <span className="hinweis">
          In SelectLine geliefert, hier noch nicht gebucht - die Menge bleibt bestellt, bis der Wareneingang ankommt
          {daten.stand ? ` (Abgleich vom ${zeitpunkt(daten.stand)})` : ''}.
        </span>
      </div>
      <ul className="befund-liste">
        {saetze.map((s) => (
          <li key={s} className="befund hinweis">
            <span className="status hinweis">wartet</span>
            <div className="befund-text">{s}</div>
          </li>
        ))}
      </ul>
      <p className="hinweis" style={{ marginBottom: 0 }}>
        Kommt der Wareneingang nicht von selbst, unter <Link to="/importe">Importe</Link> nachsehen oder in den
        Einstellungen einen Abruf „Wareneingang“ beauftragen.
      </p>
    </div>
  )
}
